import React from 'react';
import { Hero } from '../components/sections/Hero';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { SpecStatsSection } from '../components/sections/SpecStatsSection';
import { ProcessSection } from '../components/sections/ProcessSection';
import { FaqSection } from '../components/sections/FaqSection';
import { ContactBand } from '../components/sections/ContactBand';
export function Home() {
  return <>
      <Hero data-id="element-321" />
      <ProblemSection data-id="element-322" />
      <SolutionSection data-id="element-323" />
      <BenefitsSection data-id="element-324" />
      <SpecStatsSection data-id="element-325" />
      <ProcessSection data-id="element-326" />
      <FaqSection data-id="element-327" />
      <ContactBand data-id="element-328" />
    </>;
}